var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError, } from "@azure/msal-browser";
import { APP_CONFIG } from "../config/runtime-config";
import { clearAppToken } from "./appToken";
const AUTH_SCOPE = APP_CONFIG.AUTH_SCOPE;
const defaultScopes = (AUTH_SCOPE
    ? [AUTH_SCOPE]
    : ["User.Read", "openid", "profile", "offline_access"]);
export function useAuth() {
    var _a;
    const { instance, accounts, inProgress } = useMsal();
    const account = (_a = accounts === null || accounts === void 0 ? void 0 : accounts[0]) !== null && _a !== void 0 ? _a : null;
    const login = () => __awaiter(this, void 0, void 0, function* () {
        const isMobile = typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(max-width: 768px)").matches;
        try {
            const req = { scopes: defaultScopes };
            if (isMobile) {
                yield instance.loginRedirect(req);
            }
            else {
                yield instance.loginPopup(req);
                // After popup success, ensure navigation to the intended target
                try {
                    const target = (typeof sessionStorage !== "undefined" &&
                        sessionStorage.getItem("postLoginRedirect")) ||
                        "/project";
                    if (typeof window !== "undefined")
                        window.location.assign(target);
                }
                catch (_a) {
                    // ignore: navigation is best-effort
                }
            }
        }
        catch (_b) {
            // As a fallback, try redirect if popup blocked
            try {
                yield instance.loginRedirect({ scopes: defaultScopes });
            }
            catch (_c) {
                // ignore: redirect fallback is best-effort
            }
        }
    });
    const logout = () => __awaiter(this, void 0, void 0, function* () {
        clearAppToken();
        try {
            yield instance.logoutRedirect({
                account: account !== null && account !== void 0 ? account : undefined,
                postLogoutRedirectUri: "/login",
            });
        }
        catch (_a) {
            if (typeof window !== "undefined") {
                window.localStorage.clear();
                window.sessionStorage.clear();
                window.location.replace("/login");
            }
        }
    });
    const getToken = (...args_1) => __awaiter(this, [...args_1], void 0, function* (scopes = defaultScopes) {
        if (!account)
            return null;
        try {
            const res = yield instance.acquireTokenSilent({
                account,
                scopes,
            });
            return res.accessToken || null;
        }
        catch (err) {
            if (err instanceof InteractionRequiredAuthError) {
                try {
                    const res = yield instance.acquireTokenPopup({ account, scopes });
                    return res.accessToken || null;
                }
                catch (_a) {
                    try {
                        yield instance.acquireTokenRedirect({
                            account: account !== null && account !== void 0 ? account : undefined,
                            scopes,
                        });
                    }
                    catch (_b) {
                        /* noop */
                    }
                }
            }
            return null;
        }
    });
    return {
        instance,
        account,
        isAuthenticated: !!account,
        login,
        logout,
        inProgress,
        getToken,
    };
}
